// src/App.js
// Main entry point for the React application.
// This file sets up the root component and renders the main visualizer UI.

import TextEmbeddingVisualizer from "./components/TextEmbeddingVisualizer";

/**
 * App component - root of the React component tree.
 * Renders the TextEmbeddingVisualizer, which provides the main UI
 * for exploring and visualizing text embeddings.
 */
function App() {
  return <TextEmbeddingVisualizer />;
}

export default App;
